import { chain } from 'lodash';

export const focusSelect = ref =>
  chain(ref)
    .invoke('rcSelect.selectTriggerRef.triggerRef.getRootDomNode')
    .invoke('querySelector', '[class*=__rendered]')
    .invoke('click')
    .value();
